import { Textarea } from "../../../shadcn/components/ui/textarea";
import CheckIcon from "../../../icons/CheckIcon";
import { Button } from "../../../shadcn/components/ui/button";

const ConfirmationModal = (props: any) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white shadow-2xl rounded-xl w-full max-w-lg">
        <div className="w-full flex flex-col items-center px-4 py-6 border bg-[#FCFFFB] border-brand-bgGrey rounded-lg">
          <CheckIcon className="h-7 w-7 text-brand-bgSuccessGreen" />
          <div className="flex items-center space-x-3">
            <div>
              <p className="font-openSans text-[22px] font-semibold text-brand-bgBlack text-center">
                Are you sure you want to approve?
              </p>
              <p className="font-openSans text-[16px] text-gray-700 text-center mt-1">
                This action cannot be undone.
              </p>
            </div>
          </div>
          {props?.modalType === "bidder" && (
            <div className="flex-1 overflow-y-auto p-4 sm:p-6 w-full">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Remarks (Optional)
                </label>
                <Textarea
                  placeholder="Please provide a Remark for approval"
                  value={props.approveRemark}
                  onChange={(e) => props.setApproveRemark(e.target.value)}
                  className="border-[1px] border-brand-borderLightGray w-full py-2 px-4 text-sm tracking-wide font-sans text-brand-textBlack rounded min-h-[70px]"
                  disabled={props?.isLoading}
                />
              </div>
            </div>
          )}

          <div className="w-full mt-8 flex space-x-4">
            <Button
              disabled={props?.isLoading}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg w-full"
              onClick={props.onApprove} // Handle approval
            >
              Approve
            </Button>
            <Button
              disabled={props?.isLoading}
              className="bg-gray-300 text-black hover:bg-gray-400 px-6 py-2 rounded-lg w-full"
              onClick={props.onCancel} // Handle cancel
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
